module.exports = __webpack_public_path__ + "static/img/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.21bf62ca.png";